import { LoaderFunction } from "react-router-dom";
import { axiosApi } from "../../interceptors/axios";
import { PagedResponse } from "../../types/Result";
import { SystemLog } from "../log/type";

export const logListLoader: LoaderFunction = async (args) => {
  let url = new URL(args.request.url);
  const result = await axiosApi.get<PagedResponse<SystemLog>>(
    url.search
      ? `/api/systemlogs${url.search}`
      : "/api/systemlogs?sort.field=timestamp&sort.sort=desc&pageSize=50"
  );
  return result.data;
};
